<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col>
        <v-data-table
          :headers="incomingHeaders"
          :items="purchaseItems"
          :expanded.sync="expanded"
          :search="search"
          show-expand
          item-key="id"
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Bestellungen</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              />
              <v-text-field v-model="search" label="Suche" single-line append-icon="mdi-magnify" />
              <v-spacer />
              <inertia-link :href="route('purchase.create')">
                <v-btn color="primary">
                  ANLEGEN
                </v-btn>
              </inertia-link>
            </v-toolbar>
          </template>
          <template #expanded-item="{headers, item}">
            <td :colspan="headers.length">
              <v-form @submit.prevent="updateItem(item.id,item)">
                <v-simple-table :elevation="4" class="ma-3">
                  <template #default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Name
                        </th>
                        <th class="text-left">
                          Menge
                        </th>
                        <th class="text-left">
                          Geliefert
                        </th>
                        <th class="text-left">
                          Stückpreis
                        </th>
                        <th class="text-left">
                          Rechnungspreis
                        </th>
                        <th class="text-left">
                          Gesamtpreis
                        </th>
                        <th class="text-left">
                          Abgeschlossen
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(purchaseItem, key) in item.purchaseItems "
                        :key="key"
                      >
                        <td>{{ purchaseItem.name }}</td>
                        <td>{{ purchaseItem.amount }}</td>
                        <td>{{ purchaseItem.delivered }}</td>
                        <td>{{ purchaseItem.price_per_piece }}€</td>
                        <td>
                          <MoneyInputField
                            :key="key"
                            v-model="purchaseItem.invoice_price_per_piece"
                            :rules="[v => !!v || 'Item is required']"
                            required
                            label="Rechnungspreis"
                          />
                        </td>
                        <td>
                          {{ new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                          }).format(purchaseItem.amount * purchaseItem.invoice_price_per_piece ) }}
                        </td>
                        <td>
                          <v-checkbox v-model="purchaseItem.closed" :value="purchaseItem.closed" />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row>
                  <v-col cols="8">
                    <h3>
                      Dateien
                    </h3>
                    <v-row v-for="(file, key) in item.files" :key="key" class="mt-3 ml-2">
                      <v-col :key="key" cols="12" class="pa-0">
                        <a target="blanc" :href="route('purchase.file_download', file.id)">
                          {{ file.name }}
                        </a>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <div class="d-flex justify-end mb-3">
                      <v-btn text @click="confirmDelete(item.id)">
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                    <div class="d-flex justify-end mb-3">
                      <inertia-link :href="route('purchase.edit', item.id)">
                        <v-btn outlined color="primary">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </inertia-link>
                    </div>
                    <div class="d-flex justify-end mb-3">
                      <v-btn text class="mr-2" @click="fileUploadPrompt = true">
                        Datei Upload
                      </v-btn>
                      <Inertia-link :href="route('delivery_receipt.create_with_invoice',item.invoice_number )" class="mr-2">
                        <v-btn outlined color="primary">
                          LIEFERSCHEIN
                        </v-btn>
                      </Inertia-link>
                      <v-btn type="submit" color="primary">
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </td>
            <v-dialog v-model="fileUploadPrompt" width="500">
              <v-card>
                <v-card-title>
                  Dateien für - {{ item.invoice_number }} Hochladen
                </v-card-title>
                <v-divider class="my-3" />
                <v-card-text>
                  <Dropzone :files="files" :multiple="true" />
                  <v-divider class="my-3" />
                  <div class="d-flex justify-end">
                    <v-btn text class="mr-2" @click="fileUploadPrompt = false">
                      Schließen
                    </v-btn>
                    <v-btn text class="mr-2" @click="addFiles(item.id)">
                      Hochladen
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>

            <v-dialog v-model="deletePrompt" width="500">
              <v-card>
                <v-card-title>
                  Bestellung - {{ item.invoice_number }} Entfernen
                </v-card-title>
                <v-divider class="my-3" />
                <v-card-text>
                  <p>
                    Warnung bereits erstellte Lieferscheine für diese Bestellung werden ebenfalls entfernt.
                  </p>
                  <v-divider class="my-3" />
                  <div class="d-flex justify-end">
                    <v-btn text class="mr-2" @click="deletePrompt = false">
                      Schließen
                    </v-btn>
                    <v-btn color="primary" @click="softDelete()">
                      ENTFERNEN
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import MoneyInputField from '@shared/MoneyInputField'
import Dropzone from '@shared/Dropbox'
export default {
   name: 'IncomingIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Bestellungen Übersicht',
      }
   },
   components: {
      MoneyInputField,
      Dropzone
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      items: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         expanded: [],
         search: '',
         files: [],
         deletePrompt: false,
         fileUploadPrompt: false,
         purchaseItems: this.items,
         toDelete: null,
         toUpload: null,
         incomingHeaders: [
            { text: 'BestellNr', value: 'invoice_number' },
            { text: 'Status', value: 'status' },
            { text: 'Erstellt', value: 'created_at' },
            { text: '', value: 'data-table-expand' },
         ],
         createOrder: false
      }
   },
   methods: {

      confirmDelete (id) {
         this.toDelete = id
         this.deletePrompt = true
      },
      softDelete () {
         this.$inertia.get('purchase/' + this.toDelete + '/softdelete')
      },
      addFiles (id) {
         this.$inertia.post(this.route('purchase.file_upload', id), this.files)
            .then((response) => (location.reload()))
      }

   }
}
</script>

<style>

</style>
